import React, { useState, useEffect } from "react";
import "../../components/AddDesignation/AddDesignation.css";
import axios from "axios";

const AddDesignation = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const [departmentDetailResponse, setDepartmentResponse] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorageDepartment(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDepartment?department=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setDepartmentResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  useEffect(() => {
    
    tokenStorageDepartment();
  }, []);

  const [formData, setFormData] = useState({
    Desg_ID: "",
    Dept_ID: "",
    Designation: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Include selected department in the formData
      const postData = {
        ...formData,       
      };

      // Make a POST request to your API endpoint with updated postData
      const response = await axios.post(
        `${baseAPI}adminpost/AddDesignation`,
        postData, // Send updated postData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Optionally, reset the form
      setFormData({
        Desg_ID: "",
        Dept_ID: "",
        Designation: "",
        createdBy: "",
        is_active: "",
      });
      
      // tokenStorageDepartment();
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
      // Clear the selected department value
      setSelectedValue("");
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

 

  const handleSelectChange = (event) => {
    // Handle the select input change and update the selected value
    formData.Dept_ID = event.target.value;
    //setSelectedValue(event.target.value);
    
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="designationDetail">
        <div className="designation-form" >
          <table style={{ width: "100%" }}>
            <tr className="tableHeading">
              <td>Department Name*</td>
              <td>Designation Name*</td>
            </tr>

            <tr>
              <td>
                <select
                  name="Dept_ID" 
                  onChange={handleSelectChange}
                  style={{ height: "29px" }}
                >
                  <option value="">Select an option</option>
                  {departmentDetailResponse.map((item) => (
                    <option value={item.dept_id}>
                      {item.department}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="Designation"
                  value={formData.Designation}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addDesignation-button">
            <button
              type="submit" onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Add Designation
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddDesignation;
